module.exports = __webpack_public_path__ + "static/myself-ee49d98e3b742ef507da3d520661c15c.jpg";